module.exports = __webpack_public_path__ + "static/media/ArrowDownSmall.b28bb0b1.svg";